<template>
  <div class="ar">
     <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
         <svg class="icon" aria-hidden="true" style="fill: #fff">
          <use xlink:href="#icon-yinhangka"></use>
        </svg>
     </breadcrumbs>
      <div class="content">
         <div class="filters">
      <div class="search">
        <div class="option" ref="marketplaceRef">
          <span>Marketplace</span>
           <artmisads-select
            style="width: 160px"
            v-model:value="filters.marketplace"
            :getPopupContainer="() =>$refs.marketplaceRef"
            :options="COUNTRY_BASE_OPTIONS"
            @change="onMarketplaceChange"
        />
        </div>
        <div class="option">
          <span>Seller/DBA/BD</span>
           <artmisads-input v-model:value="filters.keyword" @press-enter="getList"  style="width: 160px"
            placeholder="Enter Seller/DBA/BD"></artmisads-input>
        </div>
        <div class="option">
          <span>Publisher</span>
          <artmisads-select
                  show-search
                  v-model:value="filters.publisherId"
                  style="width: 160px"
                  :options="sellerOptions"
                  @search="searchPublisher"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  placeholder="All"
                  allowClear
                  @change="onChangePublisher"
                />
        </div>
         <div class="option" ref="setCommissionRef">
          <span>PaymentDate</span>
            <a-date-picker  v-model:value="filters.paymentDateStr" placeholder="Select date" 
              class="date-picker" 
               picker="month"
            
              :getPopupContainer="() => $refs.setCommissionRef"
              />
        </div>
       <div class="option">
          <span>Received Date</span>
          <artemisads-range-picker
            v-model:value="dateParams"
            allowClear
            @openChange="openChange"
            :presets="RANGE_PRESETS_ADMIN_COMMISSIONS"
            style="width: 232px"
          
          />
        </div>
      </div>
      
    </div>
     <div class="button" ref="fileBarRef">
      <a-dropdown :getPopupContainer="() => $refs.fileBarRef">
            <template #overlay>
              <artmisads-dropdown-menu @click="handleMenuClick">
                
                <a-menu-item key="all">
                  <div class="actions-item">
                    <span>Export All</span>
                  
                  </div>
                </a-menu-item>
                <a-menu-item key="filter">
                  <div class="actions-item">
                    <span>Export with Filters</span>
                  </div>
                </a-menu-item>
              </artmisads-dropdown-menu>
            </template>
             <artmisads-button isSquare="true" type="primary" >Export</artmisads-button>
          </a-dropdown>
      
        <artmisads-button isSquare="true" type="primary" 
          @click="searchList">Search</artmisads-button>
        <artmisads-button isSquare="true" @click="onReset">Reset</artmisads-button>
      </div>
        <a-table
          ref="tableRef"
          :columns="columns"
          :dataSource="dataList"
          :pagination="pagination"
          :spinning="load"
          :rowKey="(record) => record.billingId"
          @change="onChange"
          :scroll="{ x: 1800 }"
         :expandIconColumnIndex="-1"
        :expandIconAsCell="false"
        :expandedRowKeys="expandedRowKeys"
        @expandedRowsChange="handleExpandedRowsChange"
        :columnsCanDrag="false"  
        :fixed="false" 

        >
       <template #expandedRowRender="{ record }">
        
         <div class="expanded-content" v-if="expandedARows.includes(record.billingId)" :style="expandedBRows.includes(record.billingId)?'border-bottom: 1px solid #f0f0f0;':''">
          <!-- 显示A的展开内容（如果A被展开） -->
        
          <div  style="margin-left: 1190px;"  >
           <div class="expanded-title">
              <p style="width: 100px;"> Received</p>
              <p style="width: 200px;">ReceivedDate</p>
              <p style="width: 150px;">Incoming</p>
             
            </div>
            <!--  -->
            <div v-for="(value,index) in record.receivedPaymentList"  class="expanded-content" :style="index === record.receivedPaymentList.length - 1 ? 'border-bottom: none;' : ' border-bottom: 1px solid #f0f0f0;'">
            <p style="width: 100px;">{{ value?.receivedAmount }}</p>
            <p style="width: 200px;">{{ value?.receivedDate }}</p>
            <p style="width: 150px;">{{ value?.incoming }}</p>
           </div>
           
          </div>
          </div>
          <!-- 显示B的展开内容（如果B被展开） -->
            <div class="expanded-content" v-if="expandedBRows.includes(record.billingId)">
          <div  style="margin-left: 1630px;">
            <div class="expanded-title">
              <p style="width: 150px;"> Publisher</p>
              <p style="width: 200px;">Media Commission</p>
              <p style="width: 200px;">Platform Commission</p>
              <p style="width: 250px;">ReceivedMedia Commission</p>
              <p style="width: 250px;">ReceivedPlatform Commission</p>
            </div>
           <div v-for="(value,index) in record.publisherBillingdetailVOList" :style="index === record.publisherBillingdetailVOList.length - 1 ? 'border-bottom: none;' : ' border-bottom: 1px solid #f0f0f0;'" class="expanded-content">
            <p style="width: 150px;"> {{ value.publisherName }}</p>
            <p style="width: 200px;">{{ value.commissionAmount }} </p>
            <p style="width: 200px;">{{ value.platformFeeAmount }}</p>
            <p style="width: 250px;">{{ value.receivedCommissionAmount }}</p>
            <p style="width: 250px;">{{ value.receivedPlatformFeeAmount }}</p>
            </div>
          </div>
          </div>
      </template>
      <template #bodyCell="{ column, record, text }">
        <template v-if="column.key === 'paymentDate'">
            {{ moment(record?.billingDateTimestamp).format('YYYY-MM') }}
        </template>
        <template v-else-if="column.key === 'sellerName'">
          <div>{{ record?.sellerName }}</div>
          <div class="emailStyle">{{ record?.sellerEmail }}</div>
        </template>
      </template>
      </a-table>
      </div>
  </div>
</template>
<script setup lang="jsx">
import { ref,h, computed,onMounted } from 'vue'
import breadcrumbs from "../../breadcrumbs.vue";
import { financeApi } from "~/server/operator/finance";
import moment from 'moment';
import { COUNTRY_BASE } from "~/contants/common";
  import { publisherAdminApi } from "~/server/index";
  import { RANGE_PRESETS_ADMIN_COMMISSIONS } from '~/contants/reports';
const dateParams=ref('')
const COUNTRY_BASE_OPTIONS = COUNTRY_BASE.map((item) => {
  item.value = item.host;
  item.label = item.host;
  return item;
});
// console.log(COUNTRY_BASE_OPTIONS,'COUNTRY_BASE_OPTIONS')
// 分别为A和B按钮创建独立的展开状态
const expandedARows = ref([]);
const expandedBRows = ref([]);
const onReset=()=>{
  filters.value={
    marketplace:"",
    paymentDateStr:"",
    publisherId:"",
    keyword:"",
    startReceivedDate:'',
    endReceivedDate:'',
  }
  dateParams.value=''
  getList()
}
// 展开A处理函数 - 独立控制A的展开状态
const handleExpandA = (record, e) => {
  e.stopPropagation();
  const key = record.billingId;
  
  
  // 判断当前行是否已通过展开A展开
  if (expandedARows.value.includes(key)) {
    // 如果已展开，则收起
    expandedARows.value = expandedARows.value.filter(k => k !== key);
  } else {
    // 展开当前行，不影响B的展开状态
    expandedARows.value.push(key);
  }
};
 const openChange = ()=> {
      filters.value.startReceivedDate=moment(dateParams.value[0]).format('YYYY-MM-DD')
      filters.value.endReceivedDate= moment(dateParams.value[1]).format('YYYY-MM-DD')
   
  }
// 展开B处理函数 - 独立控制B的展开状态
const handleExpandB = (record, e) => {
  e.stopPropagation();
  const key = record.billingId;
  
  // 判断当前行是否已通过展开B展开
  if (expandedBRows.value.includes(key)) {
    // 如果已展开，则收起
    expandedBRows.value = expandedBRows.value.filter(k => k !== key);
  } else {
    // 展开当前行，不影响A的展开状态
    expandedBRows.value.push(key);
  }
};

// 计算总的展开行，用于表格的expandedRowKeys
const expandedRowKeys = computed(() => {
  // 合并A和B的展开行，确保没有重复
  return [...new Set([...expandedARows.value, ...expandedBRows.value])];
});

// 展开行变化事件
const handleExpandedRowsChange = (expandedKeys) => {
  // 由于我们手动控制展开状态，这里可以留空或添加必要的同步逻辑
};
const breadcrumbsData={
   title: "Receipt Breakdowns",
   color: 'rgba(250, 172, 38, 1)',
   links: [
     {
       name: "Home",
       path: "/operator/users",
     },
     {
       name: "Finance",
       path: "/finance/payments",
     },
     {
       name: "Receipt Breakdowns",
       path: "/seller/finance/ar",
     },
   ],
}
const filters=ref({
  marketplace:"",
  paymentDateStr:"",
  publisherId:""
})
const onMarketplaceChange=(val)=>{
  filters.value.marketplace=val
}
const load=ref(false)
const dataList=ref([])
const pagination = ref({
  total: 0,
  defaultPageSize: 10,
  size: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ['10', '20', '30', '40', '50']
});


// 引入Tooltip组件

const { Tooltip } = require('ant-design-vue');

// 带Tooltip的文本渲染函数
const renderWithTooltip = (text, record, column) => {
  return h(
    Tooltip,
    {
      title: text,
      placement: 'top',
      trigger: 'hover',
      arrowPointAtCenter: true
    },
    { default: () => h('span', null, text) }
  );
};

const columns=ref([
  {
    title: 'PaymentDate',
    dataIndex: 'paymentDate',
    key: 'paymentDate',
    width: '200px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'paymentDate')
  },
  {
    title: 'Seller',
    dataIndex: 'sellerName',
    key: 'sellerName',
    width: '250px',
    ellipsis: true,
    align: 'center',
    
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'sellerName')
  },
  {
    title:'DBA',
    dataIndex: 'dbaName',
    key: 'dbaName',
    width: '100px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'dbaName')
  },
  {
    title:'BD',
    dataIndex: 'bd',
    key: 'bd',
    width: '100px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'bd')
  },
  {
    title:'invoice.No',
    dataIndex: 'invoiceNo',
    key: 'invoiceNo',
    width: '200px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'invoiceNo')
  },
  {
    title:'marketplace',
    dataIndex: 'marketplace',
    key: 'marketplace',
    width: '150px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'marketplace')
  },
  {
    title:'Currency',
    dataIndex: 'currency',
    key: 'currency',
    width: '100px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'currency')
  },
  {
    title:'Amount',
    dataIndex: 'amount',
    key: 'amount',
    width: '100px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'amount')
  },
  {    
    title:'Received',
      dataIndex: 'receivedAmount',
          key: 'receivedAmount', 
           width: '100px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
     customRender: ({ record }) => {
     const isExpanded = expandedARows.value.includes(record.billingId);
     if(record?.receivedPaymentList?.length>1){
      return h(Tooltip, {
        title: record.receivedAmount,
        placement: 'top',
        trigger: 'hover'
      }, {
        default: () => h('div', {
          style: {
            color: '#1890ff',
            cursor: 'pointer',
            fontWeight: isExpanded ? 'bold' : 'bold',
            background: isExpanded ? 'transparent' : 'transparent',
            padding: '4px 8px',
            borderRadius: '4px',
            display: 'inline-block'
          },
          onClick: (e) => handleExpandA(record, e)
        }, isExpanded ? <svg class="icon " aria-hidden="true">
            <use xlink:href="#icon-henggang-jiacu"></use>
          </svg> : <svg class="icon " aria-hidden="true">
            <use xlink:href="#icon-jiahao-cu"></use>
          </svg>)
      });
    }
    }
  },
  {
    title:'ReceivedDate',
    dataIndex: 'receivedDate',
    key: 'receivedDate',
    width: '200px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'receivedDate')
  },
  {
    title:'Incoming',
    dataIndex: 'incoming',
    key: 'incoming',
   width: '150px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'incoming')
  },
  {
    title:'Publisher',
    dataIndex: 'publisherName',
    key: 'publisherName',
     width: '150px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ record }) => {
     const isExpanded = expandedBRows.value.includes(record.billingId);
     if(record?.publisherBillingdetailVOList?.length>1){
      return h(Tooltip, {
        title: record.publisherName,
        placement: 'top',
        trigger: 'hover'
      }, {
        default: () => h('div', {
          style: {
            color: '#52c41a',
            cursor: 'pointer',
            fontWeight: isExpanded ? 'bold' : 'bold',
            background: isExpanded ? '#transparent' : 'transparent',
            padding: '4px 8px',
            borderRadius: '4px',
            display: 'inline-block'
          },
          onClick: (e) => handleExpandB(record, e)
        }, isExpanded ? <svg class="icon " aria-hidden="true">
            <use xlink:href="#icon-henggang-jiacu"></use>
          </svg> : <svg class="icon " aria-hidden="true">
            <use xlink:href="#icon-jiahao-cu"></use>
          </svg>)
      });
    }else{
      
      return record.publisherName
    }
    }
  },
  {
    title:'Media Commission',
    dataIndex: 'commissionAmount',
    key: 'commissionAmount',
   width: '200px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'commissionAmount')
  },
  {
    title:'Platform Commission',
    dataIndex: 'platformFeeAmount',
    key: 'platformFeeAmount',
   width: '200px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'platformFeeAmount')
  },
  {
    title:'ReceivedMedia Commission',
    dataIndex: 'receivedCommissionAmount',
    key: 'receivedCommissionAmount',
 width: '250px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'receivedCommissionAmount')
  },
  {
    title:'ReceivedPlatform Commission',
    dataIndex: 'receivedPlatformFeeAmount',
    key: 'receivedPlatformFeeAmount',
    width: '250px',
    ellipsis: true,
    align: 'center',
    className: 'fixed-width-col',
    customRender: ({ text, record }) => renderWithTooltip(text, record, 'receivedPlatformFeeAmount')
  }
])
  const sellerOptions = ref([]);
  const searchPublisher = async keyword => {
    let res, paramsData = { keyword, size: 100, page: 1, reviewStatus: 'Approved', };
    res = await publisherAdminApi.getPublisherList(paramsData);
    if (res && res.data) {
      sellerOptions.value = res.data.map(item => {
        item.value = item.id;
        item.label = item.creatorName;
        return item;
      })
    }
  }


const params=ref({
  page: 1,
  size: 10,
})
const onChange=(data) => {
  const { current, pageSize } = data;
  params.value.page = current;
  params.value.size = pageSize;
  pagination.value.current=current
  pagination.value.pageSize=pageSize
  getList(params); // 调用getList方法重新加载数据
 
}
const searchList=()=>{
  getList()
}
const handleMenuClick=(key)=>{
   let time = moment().format("YYYY-MM-DD");
   let param={
    ...params.value,
   
  }
  if(key=='all'){
   
  }else{
    if(filters.value.paymentDateStr){
    filters.value.paymentDateStr=moment(filters?.value?.paymentDateStr).format('YYYY-MM-DD')
  }
   param={
    ...params.value,
    ...filters.value
  }
 

  }
   financeApi.financeSellerBillingsPaymentExport({
      qs: param,
      fileName: `Receipt-Breakdowns-${time}.xlsx`,
      platform: 'operator',
    })
}
const getList=(paramsInfo)=>{
  load.value=true
  let paymentDateStr=''
  if(filters.value.paymentDateStr){
   paymentDateStr=moment(filters?.value?.paymentDateStr).format('YYYY-MM')
  }

  if(!paramsInfo){
    params.value.page=1
  }
  let param={
    ...params.value,
    ...filters.value,
    paymentDateStr:paymentDateStr
  }
  financeApi.financeSellerBillingsPayment(param).then(res=>{
  
    // 使用map函数并返回修改后的item，同时将map结果赋值给新数组

    if(res?.data?.length==0){
      dataList.value=[]
      pagination.value.total=0
     
    }else{

    
    const processedData = res?.data?.map(item=>{
      // 创建新的item对象，避免直接修改原数组中的元素
      let newItem = {...item,};
      if(item.publisherBillingdetailVOList?.length==1){
        newItem = {...newItem,...item.publisherBillingdetailVOList[0]}
      }
      if(item.receivedPaymentList?.length==1){
        newItem = {...newItem,...item.receivedPaymentList[0]}
      }
      // 必须返回修改后的item
      return newItem;
    })
    dataList.value= processedData||[]
    pagination.value.total=res.total||0
    }
  }).finally(()=>{
    load.value=false
  })
}
const handleExport=()=>{
 if(filters.value.paymentDateStr){
    filters.value.paymentDateStr=moment(filters?.value?.paymentDateStr).format('YYYY-MM-DD')
  }
   let param={
    ...params.value,
    ...filters.value
  }
  let time = moment().format("YYYY-MM-DD");
 financeApi.financeSellerBillingsPaymentExport({
      qs: param,
      fileName: `Receipt-Breakdowns-${time}.xlsx`,
      platform: 'operator',
    })
}
onMounted(async()=>{
 await getList()
})
</script>
<style scoped lang="less">
.emailStyle{

text-align: center;
  white-space: normal;
}
.expanded-title{
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  p{
   
    font-weight: 600;
  }
}
.button{
  display: flex;
  justify-content: flex-end;
  margin: 16px;
  gap: 8px;
}
.filters {
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
  .search {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    .option {
      >span {
        margin-right: 8px;
      }

      display: flex;
      align-items: center;
      margin-right: 24px;
    }
  }
}
.expanded-content::last-child{
  border-bottom: none;
}
.expanded-content{
  display: flex;
  align-items: center;
 

  p{
    width: 100px;
    padding: 16px;
    text-align: center;
  }
}
.ar {
 padding: 0 16px;
}
.content {
    padding: 16px;
    overflow: auto;
    border-radius: 12px;
    background-color: var(--color-white);
    box-shadow: var(--section-box-shadow-6);
  }
  
  /* 强制设置列宽 */
  :deep(.fixed-width-col) {
    width: 100px !important;
    min-width: 100px !important;
    max-width: 100px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  /* 确保表格头部和单元格宽度一致 */
  :deep(.ant-table-thead > tr > th.fixed-width-col),
  :deep(.ant-table-tbody > tr > td.fixed-width-col) {
    width: 100px !important;
    min-width: 100px !important;
    max-width: 100px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  :deep(.expand-icon-container) {
    display: flex;
    align-items: center;
    user-select: none;
  }
  
  :deep(.expand-icon) {
    margin-right: 8px;
    cursor: pointer;
  }
</style>
